/* unplugin-vue-components disabled */import script from "./news-list.vue?vue&type=script&lang=jsx"
export * from "./news-list.vue?vue&type=script&lang=jsx"

import "./news-list.vue?vue&type=style&index=0&id=27254840&lang=less&scoped=true"

import exportComponent from "/data1/jenkins/master_project/website-sszx/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27254840"]])

export default __exports__